import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import SideBar from './SideBar';
import {X} from "react-bootstrap-icons";

const SidebarOffCanvas = ({ show, handleClose }: {show:boolean, handleClose: () => void}) => {
    return (
        <Offcanvas show={show}  className='sidebar-styles' onHide={handleClose} placement="end">
            <Offcanvas.Header className='justify-content-end'>
                <X onClick={handleClose} className="close-icon" size='3rem' role="button" />
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className='sidebar-inner'>
                    <SideBar closeOffCanvas={handleClose} />
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default SidebarOffCanvas;